import React from 'react';
import './InitialFormLandingComponent.css'
import { Button } from '@mui/material';
 
const InitialFormLandingComponent = ({startForm}) => {
	 
	return(
		<div className='dis-flex justify-space-around'>
			<div className='dis-flex flex-column flex-grow-3'></div>
			<div className='dis-flex flex-column flex-grow-4 form-component'>
				<div className='dis-flex flex-row'>
					<div className='text-bold font-20'>
						Welcome to Lumi Nova: Tales of Courage - a therapeutic mobile game to help your child overcome their worries in a fun way!
					</div>
				</div>
				<div className='dis-flex flex-row font-20 m-t-10'>
					<div >
						You are just 1 step away from getting your game key.
					</div>
				</div>
				<div className='form-seperator'></div>
				<div className='dis-flex'>
					<Button style={{background:'var(--theme-pink)', padding: '10px 50px', textTransform: 'none'}} variant='contained' onClick={startForm} fullWidth={false}><b>Start</b></Button>
				</div>
			</div>
			<div className='dis-flex flex-column flex-grow-3'></div>
		</div>
	)
 
}
 
export default InitialFormLandingComponent;